import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCOnAccount, TrydentOnAccountData } from './on-account.js'


type TrydentOnAccountResponse = TrydentOnAccountData & { id: 'ACCOUNT' }

export const parseOnAccount = (value: unknown, selectedPaymentMethod: string): CSCOnAccount | typeof CouldNotParse => {
  if (is<TrydentOnAccountResponse>(value)) {
    const state = value.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCOnAccount(value, state)
  }
  return CouldNotParse
}
